import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    rootOne: {
        display: 'flex', 
        flexDirection: 'column',
        height: '100%',
        overflowY: 'scroll'
    },
    wrapTitle: {
        padding: '0 20px'
    },
    wrapBlock: {
        paddingLeft: 20, 
        paddingTop: 20, 
        display: 'flex'
    },
    rootTable: {
        width: 'calc(100% - 30px)', 
        borderCollapse: 'inherit',
        borderSpacing: 0,
        '.trTable': {
            
        }
    },
    trTable: {
        border: 'none',
        cursor: 'pointer',
        '&:hover': {
            background: 'rgba(255,255,255, 0.15)'
        }
    },
    root: {
        width: '100%', 
        display: 'flex', 
        overflowY: 'scroll', 
        columnGap: 20,
        justifyContent: 'space-between', 
        height: '100%'
    },
    wrapInformation: {
        width: '25%', 
        padding: 20, 
        display: 'flex', 
        flexDirection: 'column'
    },
    wrapBlockTable: {
        width: '75%',
        color: '#fff',
        height: 'calc(100vh - 215px)', 
        overflowY: 'scroll'
    },
    save: {
        padding: '5px 10px',
        borderRadius: '16px',
        maxHeight: '48px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        textTransform: 'uppercase',
        fontWeight: 400,
        fontSize: 14,
        fontFamily: "PT Sans, sans-serif",
        userSelect: 'none',
        cursor: 'pointer',
        marginRight: 12,
    },
    bgSave: {
        background: '#00a3f9',
        color: '#24263e',
        border: '1px solid #00a3f9',
    },
    bgCansel: {
        background: 'none',
        color: '#00a3f9',
        border: '1px solid #00a3f9',
    },
    bgOffBonus: {
        color: 'rgb(36, 38, 62)',
        background: 'rgb(255, 206, 1)',
        border: '1px solid rgb(255, 206, 1)',
    },
    wrapBlockButton: {
        width: '100%', 
        display: 'flex', 
        paddingBottom: 12
    },
    mr16: {
        marginRight: 16
    },

    btnJp: {
        padding: '10px 15px',
        background: '#FF3156',
        color: '#000',
        borderRadius: 4,
        cursor: 'pointer'
    },

    wrapcross: {
        background: '#fc3450', 
        display: 'inline-block',
        padding: '5.5px 10px', 
        borderRadius: '50%', 
        cursor: 'pointer'
    },
    cross: {
        width: 10, 
        height: 10, 
        padding: 0, 
        margin: 0, 
        lineHeight: 0   
    },
    block: {
        margin: '0 0 0 8px',
        verticalAlign: 'middle',
        lineHeight: '32px',
        fontSize: '12px',
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        color: '#fff',
        fontFamily: 'PT-sans, sans-serif',
        userSelect: 'none',
        cursor: 'pointer'
    },
    wrapTable: {
        background: '#494b79', 
        display: 'inline-block', 
        padding: '5.5px 10px', 
        borderRadius: '50%', 
        cursor: 'pointer'
    },
    table: {
        width: 10, 
        height: 10,
        padding: 0, 
        margin: 0, 
        lineHeight: 0, 
        fill: '#fff'
    },
    reportGamer: {
        margin: '0 0 0 8px',
        verticalAlign: 'middle',
        lineHeight: '32px',
        fontSize: '12px',
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        color: '#fff',
        fontFamily: 'PT-sans, sans-serif',
        userSelect: 'none',
        cursor: 'pointer'
    },
    wrapUser: {
        background: '#494b79', 
        display: 'inline-block', 
        padding: '5.5px 10px', 
        borderRadius: '50%', 
        cursor: 'pointer'
    },
    user: {
        width: 10, 
        height: 10, 
        padding: 0, 
        margin: 0, 
        lineHeight: 0, 
        fill: '#fff'
    },
    reportEvent: {
        margin: '0 0 0 8px',
        verticalAlign: 'middle',
        lineHeight: '32px',
        fontSize: '12px',
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        color: '#fff',
        fontFamily: 'PT-sans, sans-serif',
        userSelect: 'none',
        cursor: 'pointer'
    },
    wrapMessage: {
        background: '#494b79', 
        display: 'inline-block',
        padding: '5.5px 10px', 
        borderRadius: '50%', 
        cursor: 'pointer'
    },
    message: {
        width: 10, 
        height: 10, 
        padding: 0, 
        margin: 0, 
        lineHeight: 0, 
        fill: '#fff'
    },
    messageLabel: {
        margin: '0 0 0 8px',
        verticalAlign: 'middle',
        lineHeight: '32px',
        fontSize: '12px',
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        color: '#fff',
        fontFamily: 'PT-sans, sans-serif',
        userSelect: 'none',
        cursor: 'pointer'
    },
    wrapPassword: {
        background: '#494b79', 
        display: 'inline-block', 
        padding: '5.5px 10px', 
        borderRadius: '50%', 
        cursor: 'pointer'
    },
    password: {
        width: 10, 
        height: 10,
        padding: 0,
        margin: 0, 
        lineHeight: 0, 
        fill: '#fff'
    },
    passwordLabel: {
        margin: '0 0 0 8px',
        verticalAlign: 'middle',
        lineHeight: '32px',
        fontSize: '12px',
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        color: '#fff',
        fontFamily: 'PT-sans, sans-serif',
        userSelect: 'none',
        cursor: 'pointer'
    },
    wrapDialog: {
        minWidth: 320,
        maxWidth: 420,
        boxShadow: '0 1px 2px 0 rgb(0 0 0 / 50%), inset 0 1px 0 0 #31406d',
        backgroundColor: '#192444',
        borderRadius: 4,
        overflow: 'visible',
        padding: 16
    },
    resetPassword: {
        fontSize: 14,
        paddingRight: 48,
        textTransform: 'uppercase',
        color: '#ffce01',
        fontFamily: 'PT Sans,sans-serif',
        fontWeight: 400
    },
    mt12: {
        marginTop: 12
    },
    generate: {
        fontSize: 14,
        color: '#ffffff',
        fontFamily: 'PT Sans,sans-serif',
        fontWeight: 400
    },
    mt16: {
        marginTop: 16,
    },
    newPassword: {
        fontSize: 14,
        color: '#ffffff',
        fontFamily: 'PT Sans,sans-serif',
        fontWeight: 400 
    }
}));

export {
    useStyles,
}